<ng-container>
  <div class="candidate-filter-wrapper-cvf4782">
  <form id="candidate-filter-form" [formGroup]="candidateFilterForm">

    <div class="row">
      <ngb-accordion *ngIf="!hideCandidateSource" [activeIds]="'custom-panel-1'">
        <ngb-panel id="custom-panel-1">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-source" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">{{ orgCandidatesMode ? 'Talent' : 'Candidate' }} Source</span>
                <span [ngClass]="getBadgeClass(getCandidateSourceCount())" *ngIf="getCandidateSourceCount() > 0">
                  {{getCandidateSourceCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-source-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12" formArrayName="source">
              <div *ngFor="let jobs of jobSourcesFormarray.controls; let i=index">
                <div [formGroupName]="i" class="row">

                  <div class="custom-checkbox col-sm-6" title="Search All filters" *ngIf="!orgCandidatesMode">
                    <label class="checkbox-label font-normal">
                      <input id="candidate-filter-checkbox-all" type="checkbox" formControlName="all" (change)="jobSoucecheck($event,'all')" />
                      <span class="checkmark" style="top: -5px"></span>
                      <p class="label-ppp"> All</p>
                    </label>
                  </div>

                  <div class="custom-checkbox col-sm-6" title="Search All filters" *ngIf="!orgCandidatesMode">
                    <label class="checkbox-label font-normal">
                      <input id="candidate-filter-checkbox-marketplace" type="checkbox" formControlName="marketPlaceCandidates"
                        (change)="jobSoucecheck($event,'marketPlaceCandidates')" />
                      <span class="checkmark" style="top: -5px"></span>
                      <p class="label-ppp"> Marketplace</p>
                    </label>
                  </div>

                  <div class="col-sm-6" *ngIf="owner || orgCandidatesMode">
                    <div class="custom-checkbox" [title]="'Search My ' + (orgCandidatesMode ? 'Talents' : 'Candidates')">
                      <label class="checkbox-label font-normal">
                        <input id="candidate-filter-checkbox-mycandidates" type="checkbox" formControlName="myCandidates" (change)="jobSoucecheck($event,'myCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <div>
                          <p class="label-ppp"> {{(userType!='JOB_SEEKER' && userType !='student') ? (orgCandidatesMode ? 'My Talents' : 'My Candidates') : 'My Profile'}}</p>
                        </div>
                      </label>
                    </div>
                  </div>

                  <!-- SuperAdmin org-scoped view: My Employees toggles the employee picker below -->
                  <div class="col-sm-6" *ngIf="orgCandidatesMode">
                    <div class="custom-checkbox" title="Filter by candidates created by selected employees">
                      <label class="checkbox-label font-normal">
                        <input id="candidate-filter-checkbox-myemployees" type="checkbox" formControlName="myEmployees" (change)="jobSoucecheck($event,'myEmployees')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <div>
                          <p class="label-ppp"> My Employees</p>
                        </div>
                      </label>
                    </div>
                  </div>

                  <!-- <div class="col-sm-6" *ngIf="!filterApplied">
                    <div class="custom-checkbox" title="Search Bench Candidates">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="benchNetworkCandidates"
                          (change)="jobSoucecheck($event,'benchNetworkCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Bench Sales Network</p>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="!filterApplied">
                    <div class="custom-checkbox" title="Search Freelancer Network">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="freeLancerNetworkCandidates"
                          (change)="jobSoucecheck($event,'freeLancerNetworkCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Freelancer Network</p>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="!filterApplied">
                    <div class="custom-checkbox" title="Search MTA Network">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="mtaNetworkCandidates"
                          (change)="jobSoucecheck($event,'mtaNetworkCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> MTA Network</p>
                      </label>
                    </div>
                  </div> -->

                  <ng-container *ngIf="!filterApplied && !orgCandidatesMode">
                    <div class="col-sm-6" *ngFor="let filterItem of personalNetworks; let j = index">
                      <div class="custom-checkbox">
                        <label class="checkbox-label font-normal">
                          <input id="candidate-filter-checkbox-network-{{j}}" type="checkbox" [formControlName]="filterItem?.key"
                            (change)="jobSoucecheck($event, filterItem?.key , 'personalNetworks')"/>
                          <span class="checkmark" style="top: -5px"></span>
                          <p class="label-ppp"> {{ filterItem?.networkName }}</p>
                        </label>
                      </div>
                    </div>
                  </ng-container>

                  <!-- <div class="col-sm-6" *ngIf="!filterApplied">
                    <div class="custom-checkbox" title="Search Job seeker Network">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="jobSeekerNetworkCandidates"
                          (change)="jobSoucecheck($event,'jobSeekerNetworkCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Job Seeker Network</p>
                      </label>
                    </div>
                  </div> -->

                  <!-- Job Seekers can't own or join a workspace -->
                  <div class="col-sm-6" *ngIf="!filterApplied && !orgCandidatesMode && userType !== 'JOB_SEEKER'">
                    <div class="custom-checkbox" title="Search Workspace Candidates">
                      <label class="checkbox-label font-normal">
                        <input id="candidate-filter-checkbox-teamcandidates" type="checkbox" formControlName="teamCandidates"
                          (change)="jobSoucecheck($event,'teamCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Workspace Candidates</p>
                      </label>
                    </div>
                  </div>
                  <!-- <div class="col-sm-6" *ngIf="!FeaSugg && !filterApplied">
                    <div class="custom-checkbox" title="Search Featured Candidates">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="featured" (change)="jobSoucecheck($event,'featured')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Featured Candidates</p>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="!FeaSugg && !filterApplied">
                    <div class="custom-checkbox" title="Search Marketplace Candidates">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="suggestedCandidates"
                          (change)="jobSoucecheck($event,'suggestedCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Marketplace Candidates</p>
                      </label>
                    </div>
                  </div> -->
                  <div class="col-sm-6" *ngIf="!orgCandidatesMode">
                    <div class="custom-checkbox" >
                      <label class="checkbox-label font-normal">
                        <input id="candidate-filter-checkbox-membernetworks" type="checkbox" formControlName="memberNetworksCandidates" (change)="jobSoucecheck($event,'memberNetworksCandidates')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <div>
                          <p class="label-ppp"> Member Network </p>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="!orgCandidatesMode && userType != 'JOB_SEEKER' && businessNetworkData?.length > 0">
                    <div class="custom-checkbox" >
                      <label class="checkbox-label font-normal">
                        <input id="candidate-filter-checkbox-businessnetwork" type="checkbox" formControlName="businessNetwork" (change)="jobSoucecheck($event,'businessNetwork')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <div>
                          <p class="label-ppp"> Business Network </p>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div class="col-sm-12">

                    <div class="col-sm-12 p-0" *ngIf="!orgCandidatesMode">
                      <app-customer-filter-template
                        [filterData]="publishedByList | async"
                        [asyncSearch]="true"
                        [title]="'Published By'"
                        [this]="this"
                        [resetFilter]="candidateFilterForm.get('resetFilter').value"
                        [searchResult]="publishedPayload?.personalNetworks?.length > 0 && ['Personal Networks']"
                        [panelName]="(publishedPayload?.personalNetworks?.length > 0) ? 'custom-panel-1' : ''"
                        [filterKey]="'fullName'"
                        [filterCount]="getPublishedByCount()"
                        [isLoading]="publishedByLoading"
                        [loaderKey]="'publishedByLoading'"
                        (onSearch)="onPublishSearch($event)"
                        (onSelect)="onSelectChange($event , 'selectedPublishedBy')"
                        (onScroll)="onPublishScroll($event)"
                        >
                     </app-customer-filter-template>
                    </div>

                    <div class="col-sm-12 p-0" *ngIf="!orgCandidatesMode && jobSourcesFormarray.at(0).get('businessNetwork').value && businessNetworkData?.length > 0">
                      <app-customer-filter-template
                      [title]="'Business Networks'"
                      [filterData]="businessNetworkData"
                      [resetFilter]="candidateFilterForm.get('resetFilter').value"
                      [filterKey]="'b2bNetworkName'"
                      [panelName]="jobSourcesFormarray.at(0).get('businessNetwork').value ? 'custom-panel-1' : ''"
                      [showFilter]="true"
                      [loaderKey]="'isLoading'"
                      [filterCount]="getBusinessNetworkCount()"
                      (onSelect)="onSelectChange($event , 'selectedBusinessNetworks')"
                      [this]="this"
                      >
                      </app-customer-filter-template>
                    </div>

                    <div class="col-sm-12 p-0" *ngIf="!orgCandidatesMode && (businessNetworkData?.length > 0 ||  (userType === 'JOB_SEEKER' || membershipType === 'Free' || membershipType === 'Pro'))">
                      <app-customer-filter-template [this]="this"
                        [filterData]="customersList | async"
                        [asyncSearch]="true"
                        [resetFilter]="candidateFilterForm.get('resetFilter').value"
                        [title]="'Customer'"
                        [filterKey]="'businessName'"
                        [this]="this"
                        [isLoading]="customerLoading"
                        [loadingMore]="customerLoadingMore"
                        [loaderKey]="'customerLoading'"
                        [panelName]="(selectedBusinessNetworks?.length > 0 || jobSourcesFormarray.at(0).get('businessNetwork').value || jobSourcesFormarray.at(0).get('memberNetworksCandidates').value) ? 'custom-panel-1' : ''"
                        [filterCount]="getCustomerCount()"
                        (onSearch)="onCustomerSearch($event)"
                        (onSelect)="onSelectChange($event , 'selectedCustomers')"
                        (onScroll)="onCustomerScroll($event)"
                        [searchResult]="memberAvailable ? ['Member Networks'] : ['Business Networks' , 'Member Networks' ]"
                      >
                      </app-customer-filter-template>
                    </div>

                    <!-- SuperAdmin org-scoped view: employee picker. Title is
                         "Published By" to stay consistent with the rest of the
                         platform (the underlying field on a candidate is createdBy);
                         the trigger checkbox above is "My Employees". -->
                    <div class="col-sm-12 p-0" *ngIf="orgCandidatesMode && (jobSourcesFormarray.at(0)?.get('myEmployees')?.value || employeeOffShowing)">
                      <app-customer-filter-template
                        [filterData]="employeeList | async"
                        [title]="'Published By'"
                        [resetFilter]="candidateFilterForm.get('resetFilter').value"
                        [this]="this"
                        [panelName]="''"
                        [filterKey]="'fullName'"
                        [filterCount]="getEmployeeCount()"
                        [showFilter]="true"
                        [asyncSearch]="true"
                        [isLoading]="employeeLoadingInput || employeeOffLoading"
                        (onSearch)="onEmployeeSearch($event)"
                        (onScroll)="onEmployeeScroll($event)"
                        (onSelect)="onSelectChange($event , 'selectedEmployees')"
                        >
                      </app-customer-filter-template>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>





      <ngb-accordion>
        <ngb-panel id="custom-panel-2">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-availability" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Availability</span>
                <span [ngClass]="getBadgeClass(getAvailabilityCount())" *ngIf="getAvailabilityCount() > 0">
                  {{getAvailabilityCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-availability-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12 p-0">
              <div class="custom-checkbox  col-sm-6" title="{{checkbox.label}}"
                *ngFor="let checkbox of availablecheckbox;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input id="candidate-filter-checkbox-availability-{{i}}" type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                    (change)="availabletype($event,checkbox.label)" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{ checkbox.label }}</p>
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion>
        <ngb-panel id="custom-panel-3">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-engagement" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Engagement Type</span>
                <span [ngClass]="getBadgeClass(getEngagementTypeCount())" *ngIf="getEngagementTypeCount() > 0">
                  {{getEngagementTypeCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-engagement-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12 p-0">
              <div class="custom-checkbox  col-sm-6" title="{{checkbox.label}}"
                *ngFor="let checkbox of availableForCheckboxes;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input id="candidate-filter-checkbox-engagement-{{i}}" type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                    (change)="availableCheckboxChange($event,checkbox.label)" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{ checkbox.label }}</p>
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion *ngIf="!hideStatus">
        <ngb-panel id="custom-panel-4">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-status" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Status</span>
                <span [ngClass]="getBadgeClass(getStatusCount())" *ngIf="getStatusCount() > 0">
                  {{getStatusCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-status-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12 p-0">
              <div [ngClass]="checkbox.disable ? 'hidden' : 'block'" class="custom-checkbox  col-sm-6" title="{{checkbox.label |titlecase}}"
                *ngFor="let checkbox of statusCheckboxes;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input id="candidate-filter-checkbox-status-{{i}}" type="checkbox" name="trades" [checked]="checkbox.selected"
                    (change)="statuscheck($event,checkbox.label)" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{ checkbox.label |titlecase}}</p>
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion  *ngIf="userType != 'RECRUITER' && !hideSubmissionStatus">
        <ngb-panel id="custom-panel-5">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-submission" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Submission Status</span>
                <span [ngClass]="getBadgeClass(getSubmissionStatusCount())" *ngIf="getSubmissionStatusCount() > 0">
                  {{getSubmissionStatusCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-submission-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12 p-0">
              <div class="custom-checkbox  col-sm-6" title="{{Subcheckbox.value}}"
                *ngFor="let Subcheckbox of submissionFilter;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal ">
                  <input id="candidate-filter-checkbox-submission-{{i}}" type="checkbox" [disabled]="jobfilter==true" name="trades" [(ngModel)]="Subcheckbox.selected"
                    (change)="candidate_status_check($event,Subcheckbox.itemId)" [ngModelOptions]="{standalone: true}"/>
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{ Subcheckbox.label | titlecase}}</p>
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion>
        <ngb-panel id="custom-panel-6">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-location" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Location</span>
                <span [ngClass]="getBadgeClass(getLocationCount())" *ngIf="getLocationCount() > 0">
                  {{getLocationCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-location-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
              <div class="col-sm-12">
                <div class="row form-group app-form" [ngClass]="{'disabled': jobfilter==true}">
                  <div class="col-sm-6" style="padding-bottom: 7px">
                    <select id="candidate-filter-select-country" class="form-control input-sm" formControlName="country" type="text"
                      (change)="onChangeCountry($event.target.value)">
                      <option value="null" selected>
                        Country
                      </option>
                      <option *ngFor="let country of countryList" [value]="country.countryCode">
                        {{ country.countryName }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country == 'US'">
                    <input id="candidate-filter-input-zipcode-us" type="text" placeholder="Zip Code" formControlName="zipCode" class="form-control input-sm"
                      (keyup)="onKeyZip($event)" />
                  </div>
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country == 'CA'">
                    <select id="candidate-filter-select-state-ca" class="form-control input-sm" formControlName="state" type="text"
                      (change)="onChangestate($event.target.value)">
                      <option value="null" selected="true">
                        State
                      </option>
                      <option *ngFor="let state of stateListCA" [value]="state.stateName">
                        {{ state.stateName }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country == 'IN'">
                    <select id="candidate-filter-select-state-in" class="form-control input-sm" formControlName="state" type="text"
                      (change)="onChangestate($event.target.value)">
                      <option value="null" selected="true">
                        State
                      </option>
                      <option *ngFor="let state of stateListIN" [value]="state.stateName">
                        {{ state.stateName }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country == 'AU'">
                    <select id="candidate-filter-select-state-au" class="form-control input-sm" formControlName="state" type="text"
                      (change)="onChangestate($event.target.value)">
                      <option value="null" selected="true">
                        State
                      </option>
                      <option *ngFor="let state of stateListAU" [value]="state.stateName">
                        {{ state.stateName }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6" *ngIf="
                                      candidateFilterForm.value.country != 'AU' &&
                                      candidateFilterForm.value.country != 'IN' &&
                                      candidateFilterForm.value.country != 'CA' &&
                                      candidateFilterForm.value.country != 'US'
                                    ">
                    <input id="candidate-filter-input-state-other" type="text" placeholder="State" formControlName="state" (change)="onChangestate($event.target.value)"
                      class="form-control input-sm" />
                  </div>
                </div>
                <div class="row form-group app-form">
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country == 'US'">
                    <input id="candidate-filter-input-city-us" type="text" placeholder="City" formControlName="city" (change)="onChangecity($event.target.value)"
                      class="form-control input-sm" />
                  </div>
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country != 'US'">
                    <input id="candidate-filter-input-city-other" type="text" placeholder="City" formControlName="city" class="form-control input-sm"
                      (change)="onChangecity($event.target.value)">
                  </div>
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country != 'US'">
                    <input id="candidate-filter-input-zipcode-other" type="text" placeholder="zipcode" formControlName="zipCode"
                      (change)="onChangezipcode($event.target.value)" class="form-control input-sm" />
                  </div>
                  <div class="col-sm-6" *ngIf="candidateFilterForm.value.country == 'US'">
                    <input id="candidate-filter-input-state-us" type="text" placeholder="State" formControlName="state" (change)="onChangestate($event.target.value)"
                      class="form-control input-sm" />
                  </div>
                </div>
              </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion  *ngIf="showWorkAuthorization">
        <ngb-panel id="custom-panel-7">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-workauth" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Work Authorization</span>
                <span [ngClass]="getBadgeClass(getWorkAuthorizationCount())" *ngIf="getWorkAuthorizationCount() > 0">
                  {{getWorkAuthorizationCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-workauth-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12" *ngIf="showWorkAuthorization">
              <div class="custom-checkbox col-sm-6 ml-m15" title="{{checkbox.label}}"
                *ngFor="let checkbox of WACheckboxes;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input id="candidate-filter-checkbox-workauth-{{i}}" type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                    (change)="workAuthcheckbox($event,checkbox.label)" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp mr-10"> {{ checkbox.label }}</p>
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion>
        <ngb-panel id="custom-panel-8">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-workmode" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Work Mode</span>
                <span [ngClass]="getBadgeClass(getWorkModeCount())" *ngIf="getWorkModeCount() > 0">
                  {{getWorkModeCount()}}
                </span>
              </button>
              <button id="candidate-filter-toggle-workmode-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12 p-0">
              <div class="custom-checkbox  col-sm-6" title="{{checkbox.label}}"
                *ngFor="let checkbox of workModeCheckboxes;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input id="candidate-filter-checkbox-workmode-{{i}}" type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                  (change)="workModeChange($event.target.checked , checkbox?.label)" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{ checkbox.label }}</p>
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion>
        <ngb-panel id="custom-panel-9" [disabled]="jobfilter==true">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-experience" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Total Experience (Years)</span>
                <span [ngClass]="getBadgeClass(1)" *ngIf="!orgCandidatesMode">
                  1
                </span>
              </button>
              <button id="candidate-filter-toggle-experience-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
              <div class="col-sm-12">
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                    [value]="EXPERIENCE_ANY" style="display: none;" type="radio" id="exampleRadio0">
                  <label class="form-check-label custom-radio-label" for="exampleRadio0">
                    {{EXPERIENCE_ANY}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                    [value]="EXPERIENCE_JUNIOR" style="display: none;" type="radio" id="exampleRadio1">
                  <label class="form-check-label custom-radio-label" for="exampleRadio1">
                    {{EXPERIENCE_JUNIOR}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                    [value]="EXPERIENCE_MID_LEVEL" style="display: none;" type="radio" id="exampleRadio12">
                  <label class="form-check-label custom-radio-label" for="exampleRadio12">
                    {{EXPERIENCE_MID_LEVEL}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                    [value]="EXPERIENCE_SENIOR" style="display: none;" type="radio" id="exampleRadio3">
                  <label class="form-check-label custom-radio-label" for="exampleRadio3">
                    {{EXPERIENCE_SENIOR}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                    [value]="EXPERIENCE_ARCHITECT" style="display: none;" type="radio" id="exampleRadio4">
                  <label class="form-check-label custom-radio-label" for="exampleRadio4">
                    {{EXPERIENCE_ARCHITECT}}
                  </label>
                </div>
              </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <ngb-accordion>
        <ngb-panel id="custom-panel-10" [disabled]="jobfilter==true">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button id="candidate-filter-toggle-posted" ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Posted (Days)</span>
                <span [ngClass]="getBadgeClass(1)" *ngIf="!orgCandidatesMode">
                  1
                </span>
              </button>
              <button id="candidate-filter-toggle-posted-chevron" ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
              <div class="col-sm-12">
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                    [value]="POSTED_ANY" style="display: none;" type="radio" id="exampleRadio00">
                  <label class="form-check-label custom-radio-label" for="exampleRadio00">
                    {{POSTED_ANY}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                    [value]="POSTED_TODAY" style="display: none;" type="radio" id="exampleRadio11">
                  <label class="form-check-label custom-radio-label" for="exampleRadio11">
                    {{POSTED_TODAY}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                    [value]="POSTED_LAST_7_DAYS" style="display: none;" type="radio" id="exampleRadio44">
                  <label class="form-check-label custom-radio-label" for="exampleRadio44">
                    {{POSTED_LAST_7_DAYS}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                    [value]="POSTED_LAST_14_DAYS" style="display: none;" type="radio" id="exampleRadio22">
                  <label class="form-check-label custom-radio-label" for="exampleRadio22">
                    {{POSTED_LAST_14_DAYS}}
                  </label>
                </div>
                <div class="custom-form-check">
                  <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                    [value]="POSTED_LAST_30_DAYS" style="display: none;" type="radio" id="exampleRadio33">
                  <label class="form-check-label custom-radio-label" for="exampleRadio33">
                    {{POSTED_LAST_30_DAYS}}
                  </label>
                </div>
              </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>

      <app-common-skeleton *ngIf="isLoading"  [NameOftheScreen]="'verticalCheckboxSelection'"></app-common-skeleton>

    </div>

  </form>
  </div>
 </ng-container>
